import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Printer } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

// Toggle 58/80 mm para una sucursal. Compacto (tabla admin) o tarjeta (gerente).
export default function ImpresoraSucursal({ sucursal, compacto = false, onChange }) {
  const [f, setF] = useState(sucursal?.ticket_formato || "");
  useEffect(() => { setF(sucursal?.ticket_formato || ""); }, [sucursal]);
  async function guardar(v) {
    try {
      await api.put(`/sucursales/${sucursal.id}/impresora`, { ticket_formato: v });
      setF(v); onChange?.(v);
      toast.success(`${sucursal.nombre}: tickets a ${v === "58" ? "58" : "80"} mm`);
    } catch (e) { toast.error(formatApiError(e)); }
  }
  if (!sucursal) return null;
  const botones = ["58", "80"].map((v) => (
    <button key={v} data-testid={`impresora-${v}-${sucursal.id}`} onClick={() => guardar(v)} className={`px-3 h-8 rounded-full text-xs font-bold transition-colors ${f === v ? "bg-brand-ink text-white" : "bg-brand-surface text-brand-slate hover:text-brand-ink"}`}>{v} mm</button>
  ));
  if (compacto) return <div className="flex items-center gap-1" data-testid={`impresora-sucursal-${sucursal.id}`}>{botones}{!f && <span className="text-[10px] text-brand-muted ml-1">global</span>}</div>;
  return (
    <div className="surface-card p-4 flex items-center justify-between flex-wrap gap-3" data-testid="impresora-sucursal-card">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-brand-amber-soft flex items-center justify-center"><Printer className="w-5 h-5 text-brand-amber-dark" /></div>
        <div><div className="font-display font-bold text-brand-ink text-sm">Impresora de tickets · {sucursal.nombre}</div><div className="text-xs text-brand-muted">Elige el ancho del rollo; todos los tickets y cortes de esta sucursal se ajustan automáticamente.{!f && " Sin definir: usa el formato global."}</div></div>
      </div>
      <div className="flex items-center gap-1">{botones}</div>
    </div>
  );
}
